/*
 * judgeme-review-filter.js v3.4
 * Logic only. Rules come from window.__JRF__ (snippet).
 * Changelog:
 *   v3.4 - No longer exits when cfg.scope is missing; falls back to
 *          '.apex-judgeme-wrap' then '.jdgm-rev-widg' (product widget
 *          class). Homepage all-reviews widget (.jdgm-all-rev-widg)
 *          is explicitly excluded and never touched.
 *   v3.3 - Scope limited to config selector.
 *   v3.2 - Perf: scoped observer. Split-node tab label patch.
 *   v3.0 - Split into asset (logic) + snippet (config).
 */
(function () {
  'use strict';

  var cfg = window.__JRF__ || {};
  var HIDE_RULES = cfg.hideRules || [];
  var HIDDEN_BY_RATING = cfg.hiddenByRating || {};
  var DEBUG = !!cfg.debug;

  if (!HIDE_RULES.length) return;

  var SCOPES = [];
  if (cfg.scope) SCOPES.push(cfg.scope);
  SCOPES.push('.apex-judgeme-wrap');
  SCOPES.push('.jdgm-rev-widg');

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[jrf]'].concat([].slice.call(arguments)));
    }
  }

  function normalize(s) {
    return (s || '').toLowerCase();
  }

  // Widget container. Tries configured scope, then known product-widget
  // containers. The homepage all-reviews widget (.jdgm-all-rev-widg,
  // with its own Load More pagination) is never accepted.
  function getRoot() {
    for (var i = 0; i < SCOPES.length; i++) {
      var el = document.querySelector(SCOPES[i]);
      if (!el) continue;
      if (el.closest && el.closest('.jdgm-all-rev-widg')) continue;
      if (el.classList.contains('jdgm-all-rev-widg')) continue;
      return el;
    }
    return null;
  }

  // ---------- Part 1: remove matching review cards ----------
  function hideCards(root) {
    var cards = root.querySelectorAll('.jdgm-rev');
    var removed = false;
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.closest && card.closest('.jdgm-all-rev-widg')) continue;
      var author = normalize(
        (card.querySelector('.jdgm-rev__author') || {}).textContent
      );
      var content = normalize(
        ((card.querySelector('.jdgm-rev__body') || {}).textContent || '') +
        ' ' +
        ((card.querySelector('.jdgm-rev__title') || {}).textContent || '')
      );
      for (var j = 0; j < HIDE_RULES.length; j++) {
        var rule = HIDE_RULES[j];
        var authorOk =
          !rule.author || author.indexOf(normalize(rule.author)) !== -1;
        if (authorOk && content.indexOf(normalize(rule.keyword)) !== -1) {
          card.parentNode && card.parentNode.removeChild(card);
          removed = true;
          log('removed card:', rule.author || '(any)', '/', rule.keyword);
          break;
        }
      }
    }
    if (removed) {
      // Force Judge.me masonry to recalculate positions.
      window.dispatchEvent(new Event('resize'));
    }
  }

  // ---------- Part 2: recalc summary ----------
  function origFrequency(row) {
    // Cache the first-seen (server) value so repeated sweeps
    // never subtract twice.
    var cached = row.getAttribute('data-jrf-orig');
    if (cached !== null) return parseInt(cached, 10) || 0;
    var v = parseInt(row.getAttribute('data-frequency'), 10) || 0;
    row.setAttribute('data-jrf-orig', String(v));
    return v;
  }

  function patchSummary(root) {
    var rows = root.querySelectorAll('.jdgm-histogram__row[data-rating]');
    if (!rows.length) return;

    // Pass 1: collect adjusted counts.
    var adjusted = {};
    var rowByRating = {};
    var newTotal = 0;
    var newSum = 0;
    var i, rating;
    for (i = 0; i < rows.length; i++) {
      rating = parseInt(rows[i].getAttribute('data-rating'), 10);
      if (!rating || rating < 1 || rating > 5) continue;
      var c = Math.max(
        0, origFrequency(rows[i]) - (HIDDEN_BY_RATING[rating] || 0)
      );
      adjusted[rating] = c;
      rowByRating[rating] = rows[i];
      newTotal += c;
      newSum += c * rating;
    }
    if (newTotal <= 0) return;
    var newAvg = (newSum / newTotal).toFixed(2);

    // Pass 2: write back per-row values.
    for (rating = 1; rating <= 5; rating++) {
      var row = rowByRating[rating];
      if (!row) continue;
      var c2 = adjusted[rating];
      var pct = Math.round((c2 / newTotal) * 100);
      if (row.getAttribute('data-frequency') !== String(c2)) {
        row.setAttribute('data-frequency', String(c2));
        row.setAttribute('data-percentage', String(pct));
      }
      var freqEl = row.querySelector('.jdgm-histogram__frequency');
      if (freqEl && freqEl.textContent !== String(c2)) {
        freqEl.textContent = String(c2);
      }
      var bar = row.querySelector('.jdgm-histogram__bar-content');
      if (bar) bar.style.width = pct + '%';
      var starBtn = row.querySelector('.jdgm-histogram__star');
      if (starBtn) {
        starBtn.setAttribute(
          'aria-label',
          pct + '% (' + c2 + ') reviews with ' + rating + ' star rating'
        );
      }
      // Avoid an empty filtered view for fully-hidden ratings.
      if (c2 === 0 && (HIDDEN_BY_RATING[rating] || 0) > 0) {
        row.style.pointerEvents = 'none';
      }
    }

    // Average text, e.g. "4.77 out of 5".
    var avgEl = root.querySelector('.jdgm-rev-widg__summary-average');
    if (avgEl) {
      var newAvgText = avgEl.textContent.replace(/\d+\.\d+/, newAvg);
      if (avgEl.textContent !== newAvgText) avgEl.textContent = newAvgText;
    }

    // "Based on N reviews".
    var sumEl = root.querySelector('.jdgm-rev-widg__summary-text');
    if (sumEl) {
      var newSumText = sumEl.textContent.replace(/\d[\d,]*/, String(newTotal));
      if (sumEl.textContent !== newSumText) sumEl.textContent = newSumText;
    }

    // Original (server) total, used to find unpatched labels.
    var origTotal = 0;
    for (rating = 1; rating <= 5; rating++) {
      var r2 = rowByRating[rating];
      if (r2) origTotal += parseInt(r2.getAttribute('data-jrf-orig'), 10) || 0;
    }

    patchTabLabel(root, origTotal, newTotal);
    log('summary: total', newTotal, 'avg', newAvg);
  }

  // ---------- Tab label: element-based, split-node tolerant ----------
  function patchTabLabel(root, origTotal, newTotal) {
    if (origTotal === newTotal) return;
    // The tabs may sit outside the histogram container, so search the
    // whole review widget area.
    var area = root.closest('.apex-judgeme-wrap') || root;
    var tabRe = new RegExp('Reviews\\s*\\(\\s*' + origTotal + '\\s*\\)');
    var els = area.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-jrf-tab') === '1') continue;
      if (!tabRe.test(el.textContent)) continue;

      // Only patch the DEEPEST matching element.
      var childMatch = false;
      for (var k = 0; k < el.children.length; k++) {
        if (tabRe.test(el.children[k].textContent)) {
          childMatch = true;
          break;
        }
      }
      if (childMatch) continue;

      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var node;
      var done = false;

      // Case A: full "Reviews (134)" inside one text node.
      while ((node = walker.nextNode())) {
        if (tabRe.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(
            tabRe, 'Reviews (' + newTotal + ')'
          );
          done = true;
        }
      }

      // Case B: the count lives in its own text node (split markup).
      if (!done) {
        walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
        while ((node = walker.nextNode())) {
          if (node.nodeValue.replace(/\D/g, '') === String(origTotal)) {
            node.nodeValue = node.nodeValue.replace(
              String(origTotal), String(newTotal)
            );
            done = true;
            break;
          }
        }
      }

      if (done) {
        el.setAttribute('data-jrf-tab', '1');
        log('patched tab label ->', newTotal);
      }
    }
  }

  // ---------- Scheduler ----------
  var scheduled = false;
  function scheduleSweep() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sweep();
    });
  }

  function sweep() {
    var root = getRoot();
    if (!root) return;
    hideCards(root);
    patchSummary(root);
  }

  var widgetObserver = null;

  function observeWidget(root) {
    if (widgetObserver) return;
    widgetObserver = new MutationObserver(scheduleSweep);
    var target = root.closest('.apex-judgeme-wrap') || root;
    widgetObserver.observe(target, { childList: true, subtree: true });
    log('observer attached');
  }

  function init() {
    log('init v3.4, rules:', HIDE_RULES.length);
    var root = getRoot();
    if (root) {
      observeWidget(root);
      sweep();
    } else {
      // Watch body ONLY until a valid container appears, then hand off.
      var waiter = new MutationObserver(function () {
        var r = getRoot();
        if (r) {
          waiter.disconnect();
          observeWidget(r);
          sweep();
        }
      });
      waiter.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        if (!widgetObserver) {
          waiter.disconnect();
          log('no product review widget on this page');
        }
      }, 10000);
    }
    setTimeout(sweep, 1500);
    setTimeout(sweep, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();